import { api } from '../lib/api'

export type ReviewAuthor = {
  id?: string | number
  profile_public_id?: string
  display_name?: string
  handle?: string
  avatar_url?: string | null
}

export type Review = {
  id: number
  subject: number
  overall_rating: number
  body?: string
  is_verified?: boolean
  created_at: string
  author_profile?: ReviewAuthor
}

export type ReviewAggregate = {
  subject: {
    id: number
    subject_type: string
    public_id?: string
    title?: string
  }
  count_total: number
  count_verified: number
  count_with_media: number
  rating_hist: number[]
  mean_raw: number
  bayesian_avg: number
}

export async function fetchReviewsForSubject(subjectId: number): Promise<{ results: Review[]; next?: string | null }> {
  const { data } = await api.get(`/api/reviews/reviews/for_subject/`, { params: { subject: subjectId } })
  return data
}

export async function fetchReviewAggregates(subjectId: number): Promise<ReviewAggregate | null> {
  try {
    const { data } = await api.get<ReviewAggregate>(`/api/reviews/reviews/aggregates/`, { params: { subject: subjectId } })
    return data
  } catch (e: any) {
    return null
  }
}

export async function createReview(payload: { subject: number; overall_rating: number; body?: string }) {
  const { data } = await api.post<Review>(`/api/reviews/reviews/`, payload)
  return data
}
